import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module mention/ui/domwrapperview
 */
import View from '@ckeditor/ckeditor5-ui/src/view';
/**
 * This class wraps DOM element as a CKEditor5 UI View.
 *
 * It allows to render any DOM element and use it in mentions list.
 */

var DomWrapperView =
/*#__PURE__*/
function (_View) {
  _inherits(DomWrapperView, _View);

  /**
   * Creates an instance of {@link module:mention/ui/domwrapperview~DomWrapperView} class.
   *
   * Also see {@link #render}.
   *
   * @param {module:utils/locale~Locale} [locale] The localization services instance.
   * @param {Element} domElement
   */
  function DomWrapperView(locale, domElement) {
    var _this;

    _classCallCheck(this, DomWrapperView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DomWrapperView).call(this, locale)); // Disable template rendering on this view.

    _this.template = false;
    /**
     * The DOM element for which wrapper was created.
     *
     * @type {Element}
     */

    _this.domElement = domElement; // Render dom wrapper as a button.

    _this.domElement.classList.add('ck-button');
    /**
     * Controls whether the dom wrapper view is "on". This is in line with {@link module:ui/button/button~Button#isOn} property.
     *
     * @observable
     * @default true
     * @member {Boolean} #isOn
     */


    _this.set('isOn', false); // Handle isOn state as in buttons.


    _this.on('change:isOn', function (evt, name, isOn) {
      if (isOn) {
        _this.domElement.classList.add('ck-on');

        _this.domElement.classList.remove('ck-off');
      } else {
        _this.domElement.classList.add('ck-off');

        _this.domElement.classList.remove('ck-on');
      }
    }); // Pass click event as execute event.


    _this.listenTo(_this.domElement, 'click', function () {
      _this.fire('execute');
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(DomWrapperView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(DomWrapperView.prototype), "render", this).call(this);

      this.element = this.domElement;
    }
  }]);

  return DomWrapperView;
}(View);

export { DomWrapperView as default };